import { LockOpenIcon } from './LockOpenIcon';

/**
 * author: Google
 * id E357D5CD-7E42-463B-899A-7D7B038A3E31
 * name lock-open
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open.svg
 * tags
 * - Lock 
 * - Home Automation 
 * - Automotive 
 */
export const DecryptedIcon = LockOpenIcon;
export default DecryptedIcon